import { Moment } from 'moment';
import { ColaboradorDispendioOutro } from './colaborador-dispendio-outros.model';
import { TipoDispendio } from './tipo-dispendio.model';
export class DispendioOutros {

  id: number;
  idProjeto: number;
  tipoDispendio: TipoDispendio;
  descricao: string;
  valor: number;
  idPessoaJuridicaContratada: number;
  idHistoricoPessoaJuridicaContratada: number;
  idPessoaFisicaContratada: number;
  idHistoricoPessoaFisicaContratada: number;
  quantidade: number;
  dataInicio: Moment;
  dataFim: Moment;
  quantidadeCargaHoraria: number;
  justificativa: string;
  dispendioProprio: boolean;
  dispendioImportado: boolean;
  colaboradores: ColaboradorDispendioOutro[];
  checked?: boolean;
  materialConsumoPrototipo?: boolean;

  constructor(init?: Partial<DispendioOutros>) {
    Object.assign(this, init);
  }
}
